import styled from '@emotion/styled';
import { Button } from '@mui/material';
import mobiuspackLogo from '../../../assets/logos/mobiuspack-white-logo.svg';
import backgroundSVG from '../../../assets/logos/background-mob.svg';

/**
 * ErrorPageV3 — Page d'erreur V3 pour ErrorBoundary
 * Affichée lors d'une erreur React non catchée
 */

export default function ErrorPageV3({ errorCode = 'Oups !', message = 'Une erreur inattendue s\'est produite', onRetry }) {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <Container>
      <Logo src={mobiuspackLogo} alt="MOBIUSpack" />
      <ContentBox>
        <ErrorCode>{errorCode}</ErrorCode>
        <Message>{message}</Message>
        <ButtonGroup>
          {onRetry && (
            <StyledButton variant="contained" onClick={onRetry}>
              Réessayer
            </StyledButton>
          )}
          <StyledButton variant="outlined" onClick={handleGoHome}>
            Retour à l'accueil
          </StyledButton>
        </ButtonGroup>
      </ContentBox>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${p => p.theme.palette.background.default};
  background-image: url(${backgroundSVG});
  background-size: cover;
  background-position: right 50% top -50vw;
  background-repeat: no-repeat;
  text-align: center;
  padding: 32px 20px;
  box-sizing: border-box;
`;

const Logo = styled.img`
  max-width: 320px;
  width: 100%;
  align-self: center;
  margin-bottom: 40px;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const ErrorCode = styled.h1`
  font-size: 96px;
  font-weight: 700;
  color: ${p => p.theme.palette.primary.main};
  margin: 0 0 16px 0;
  font-family: ${p => p.theme.typography.fontFamily};
`;

const Message = styled.h2`
  font-size: 24px;
  font-weight: 400;
  color: ${p => p.theme.palette.text.primary};
  margin: 0 0 32px 0;
  font-family: ${p => p.theme.typography.fontFamily};
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 320px;
`;

const StyledButton = styled(Button)`
  text-transform: none;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  font-family: ${p => p.theme.typography.fontFamily};
`;
